import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import DefaultButtonGroup from "./ContainedGroup/DefaultButtonGroup";
import DefaultButtonGroupVertical from "./ContainedGroup/DefaultButtonGroupVertical";
import DefaultButtonGroupHorzSplit from "./ContainedGroup/DefaultButtonGroupHorzSplit";
import DefaultButtonGroupVertSplit from "./ContainedGroup/DefaultButtonGroupVertSplit";

const ContainedButtons = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Contained Button Group
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the default button Group.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <DefaultButtonGroup />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonGroupHorzSplit />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonGroupVertical />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonGroupVertSplit />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default ContainedButtons;
